import getFormatStates from 'owa-editor/lib/utils/getFormatStates';
import setContextualFormatBarTarget from '../actions/setContextualFormatBarTarget';
import updateFirstClassState from '../actions/updateFirstClassState';
import updateRibbonState from '../actions/updateRibbonState';
import { orchestrator } from 'satcheljs';

// The interval to pull ribbon state
const RIBBON_STATE_POLL_INTERVAL: number = 500;

let ribbonStateJobId: number;

orchestrator(updateRibbonState, actionMessage => {
    const { editorViewState, viewState, updateContextualFormatBar, delay } = actionMessage;

    if (ribbonStateJobId) {
        window.clearTimeout(ribbonStateJobId);
    }

    ribbonStateJobId = window.setTimeout(
        () => {
            ribbonStateJobId = null;
            const format = getFormatStates(editorViewState, updateContextualFormatBar);

            if (format) {
                const { pendableState, elementBasedState, undoState, cursorPosition } = format;

                updateFirstClassState(
                    viewState.formatViewState,
                    pendableState,
                    elementBasedState,
                    undoState
                );

                if (updateContextualFormatBar && !!cursorPosition != !!viewState.targetPoint) {
                    setContextualFormatBarTarget(viewState, cursorPosition);
                }
            }
        },
        delay ? RIBBON_STATE_POLL_INTERVAL : 0
    );
});
